const Info = {
    greeting: 'Thank you! Your account request has been received.',
    acknowledgementLine1: 'An acknowledgement email will be sent to ',
    acknowledgementLine2: '. An HID representative will contact you soon to complete your account.',
    contact: 'For immediate assistance, please contact ',
    contactEmail: 'mobileorders@hidglobal.com',
    contactTrail: ' for more details.'
}

export default Info;